export default {"src":"/_next/static/media/Charles.9ce86895.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};